import { render, staticRenderFns } from "./SeverityBadgeView.vue?vue&type=template&id=2a535ebc&scoped=true&"
import script from "./SeverityBadgeView.vue?vue&type=script&lang=js&"
export * from "./SeverityBadgeView.vue?vue&type=script&lang=js&"
import style0 from "./SeverityBadgeView.vue?vue&type=style&index=0&id=2a535ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a535ebc",
  null
  
)

export default component.exports